// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__36WfO","tab":"Tabs_tab__3UvFA","tabActive":"Tabs_tabActive__2KyOk"};